import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3af280a3 = () => interopDefault(import('../../../pages/about-callia/index.vue' /* webpackChunkName: "pages/about-callia/index" */))
const _83dfe29a = () => interopDefault(import('../../../pages/account.vue' /* webpackChunkName: "pages/account" */))
const _9b22c628 = () => interopDefault(import('../../../pages/account/add-address.vue' /* webpackChunkName: "pages/account/add-address" */))
const _ad8c7074 = () => interopDefault(import('../../../pages/account/addresses.vue' /* webpackChunkName: "pages/account/addresses" */))
const _2f004cac = () => interopDefault(import('../../../pages/account/change-name.vue' /* webpackChunkName: "pages/account/change-name" */))
const _776fffac = () => interopDefault(import('../../../pages/account/change-number.vue' /* webpackChunkName: "pages/account/change-number" */))
const _17bf4f88 = () => interopDefault(import('../../../pages/account/change-password.vue' /* webpackChunkName: "pages/account/change-password" */))
const _a74bc186 = () => interopDefault(import('../../../pages/account/edit-address.vue' /* webpackChunkName: "pages/account/edit-address" */))
const _7b82dc67 = () => interopDefault(import('../../../pages/account/order-details.vue' /* webpackChunkName: "pages/account/order-details" */))
const _a658681e = () => interopDefault(import('../../../pages/account/orders.vue' /* webpackChunkName: "pages/account/orders" */))
const _7d4d1e9e = () => interopDefault(import('../../../pages/account/view.vue' /* webpackChunkName: "pages/account/view" */))
const _4a00e952 = () => interopDefault(import('../../../pages/black-friday.vue' /* webpackChunkName: "pages/black-friday" */))
const _4304090e = () => interopDefault(import('../../../pages/bouquet-subscription.vue' /* webpackChunkName: "pages/bouquet-subscription" */))
const _4f761438 = () => interopDefault(import('../../../pages/bouquetexperiences.vue' /* webpackChunkName: "pages/bouquetexperiences" */))
const _3df0d176 = () => interopDefault(import('../../../pages/bouquetkit.vue' /* webpackChunkName: "pages/bouquetkit" */))
const _e46039e4 = () => interopDefault(import('../../../pages/bulk-florals.vue' /* webpackChunkName: "pages/bulk-florals" */))
const _4883cc1c = () => interopDefault(import('../../../pages/callia-campus.vue' /* webpackChunkName: "pages/callia-campus" */))
const _a9f91b12 = () => interopDefault(import('../../../pages/callias-birthday.vue' /* webpackChunkName: "pages/callias-birthday" */))
const _e08117ec = () => interopDefault(import('../../../pages/cart.vue' /* webpackChunkName: "pages/cart" */))
const _0012cdc4 = () => interopDefault(import('../../../pages/change-password.vue' /* webpackChunkName: "pages/change-password" */))
const _6fa999f0 = () => interopDefault(import('../../../pages/collection.vue' /* webpackChunkName: "pages/collection" */))
const _928789a6 = () => interopDefault(import('../../../pages/contact-callia.vue' /* webpackChunkName: "pages/contact-callia" */))
const _10884d6b = () => interopDefault(import('../../../pages/corporate.vue' /* webpackChunkName: "pages/corporate" */))
const _74b5f227 = () => interopDefault(import('../../../pages/donations.vue' /* webpackChunkName: "pages/donations" */))
const _2dfb1658 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _21236146 = () => interopDefault(import('../../../pages/events/index.vue' /* webpackChunkName: "pages/events/index" */))
const _8c9cd058 = () => interopDefault(import('../../../pages/experience.vue' /* webpackChunkName: "pages/experience" */))
const _ca324bc8 = () => interopDefault(import('../../../pages/faq.vue' /* webpackChunkName: "pages/faq" */))
const _0e44a436 = () => interopDefault(import('../../../pages/final-invoice-confirmation.vue' /* webpackChunkName: "pages/final-invoice-confirmation" */))
const _4029a8d8 = () => interopDefault(import('../../../pages/flower-day.vue' /* webpackChunkName: "pages/flower-day" */))
const _3292d825 = () => interopDefault(import('../../../pages/galentines-day.vue' /* webpackChunkName: "pages/galentines-day" */))
const _5543de20 = () => interopDefault(import('../../../pages/gift-cards.vue' /* webpackChunkName: "pages/gift-cards" */))
const _cdff8d6c = () => interopDefault(import('../../../pages/greet-not-found.vue' /* webpackChunkName: "pages/greet-not-found" */))
const _5e9ff9f4 = () => interopDefault(import('../../../pages/greets.vue' /* webpackChunkName: "pages/greets" */))
const _649df516 = () => interopDefault(import('../../../pages/holiday-offers.vue' /* webpackChunkName: "pages/holiday-offers" */))
const _6fe224f6 = () => interopDefault(import('../../../pages/holidays.vue' /* webpackChunkName: "pages/holidays" */))
const _204e42e5 = () => interopDefault(import('../../../pages/mothers-day.vue' /* webpackChunkName: "pages/mothers-day" */))
const _2876d73c = () => interopDefault(import('../../../pages/people/index.vue' /* webpackChunkName: "pages/people/index" */))
const _58b07eb6 = () => interopDefault(import('../../../pages/places.vue' /* webpackChunkName: "pages/places" */))
const _7dec6fac = () => interopDefault(import('../../../pages/rewards.vue' /* webpackChunkName: "pages/rewards" */))
const _04c6ab75 = () => interopDefault(import('../../../pages/rickis-x-callia.vue' /* webpackChunkName: "pages/rickis-x-callia" */))
const _211f388a = () => interopDefault(import('../../../pages/sign-in.vue' /* webpackChunkName: "pages/sign-in" */))
const _0406ba31 = () => interopDefault(import('../../../pages/sign-up.vue' /* webpackChunkName: "pages/sign-up" */))
const _328af3d6 = () => interopDefault(import('../../../pages/special-offers.vue' /* webpackChunkName: "pages/special-offers" */))
const _67fef701 = () => interopDefault(import('../../../pages/thanksgiving.vue' /* webpackChunkName: "pages/thanksgiving" */))
const _1cbd3320 = () => interopDefault(import('../../../pages/the-fine-print.vue' /* webpackChunkName: "pages/the-fine-print" */))
const _91c1d014 = () => interopDefault(import('../../../pages/valentines-day.vue' /* webpackChunkName: "pages/valentines-day" */))
const _0e24b952 = () => interopDefault(import('../../../pages/workshops.vue' /* webpackChunkName: "pages/workshops" */))
const _140ca585 = () => interopDefault(import('../../../pages/about-callia/our-story.vue' /* webpackChunkName: "pages/about-callia/our-story" */))
const _719cd20e = () => interopDefault(import('../../../pages/events/how-it-works.vue' /* webpackChunkName: "pages/events/how-it-works" */))
const _20bf4ab5 = () => interopDefault(import('../../../pages/people/drivers.vue' /* webpackChunkName: "pages/people/drivers" */))
const _667a9572 = () => interopDefault(import('../../../pages/wedding-flowers/city-landing/index.vue' /* webpackChunkName: "pages/wedding-flowers/city-landing/index" */))
const _14cac804 = () => interopDefault(import('../../../pages/wedding-flowers/deposit-confirmation.vue' /* webpackChunkName: "pages/wedding-flowers/deposit-confirmation" */))
const _6aa9c7b7 = () => interopDefault(import('../../../pages/wedding-flowers/how-it-works.vue' /* webpackChunkName: "pages/wedding-flowers/how-it-works" */))
const _8e02d1bc = () => interopDefault(import('../../../pages/wedding-flowers/old-index.vue' /* webpackChunkName: "pages/wedding-flowers/old-index" */))
const _39c15511 = () => interopDefault(import('../../../pages/wedding-flowers/tip.vue' /* webpackChunkName: "pages/wedding-flowers/tip" */))
const _5fd38417 = () => interopDefault(import('../../../pages/wedding-flowers/wedding-form.vue' /* webpackChunkName: "pages/wedding-flowers/wedding-form" */))
const _1581ac4f = () => interopDefault(import('../../../pages/wedding-flowers/wedding-gallery.vue' /* webpackChunkName: "pages/wedding-flowers/wedding-gallery" */))
const _1bfd87d8 = () => interopDefault(import('../../../pages/order/update/guest/order-details/index.vue' /* webpackChunkName: "pages/order/update/guest/order-details/index" */))
const _51d8382e = () => interopDefault(import('../../../pages/order/update/guest/verify/_orderId.vue' /* webpackChunkName: "pages/order/update/guest/verify/_orderId" */))
const _a17142a2 = () => interopDefault(import('../../../pages/care-tips/_productType.vue' /* webpackChunkName: "pages/care-tips/_productType" */))
const _50476f93 = () => interopDefault(import('../../../pages/city/_city/index.vue' /* webpackChunkName: "pages/city/_city/index" */))
const _fa5c2cf0 = () => interopDefault(import('../../../pages/occasion/_occasion.vue' /* webpackChunkName: "pages/occasion/_occasion" */))
const _18d55530 = () => interopDefault(import('../../../pages/product/_sku.vue' /* webpackChunkName: "pages/product/_sku" */))
const _245f2c4c = () => interopDefault(import('../../../pages/province/_province.vue' /* webpackChunkName: "pages/province/_province" */))
const _313318fa = () => interopDefault(import('../../../pages/v/_greetVideoRedirect.vue' /* webpackChunkName: "pages/v/_greetVideoRedirect" */))
const _2e913e0a = () => interopDefault(import('../../../pages/video/_video/share.vue' /* webpackChunkName: "pages/video/_video/share" */))
const _c5eadc6c = () => interopDefault(import('../../../pages/city/_city/_occasion/index.vue' /* webpackChunkName: "pages/city/_city/_occasion/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-callia",
    component: _3af280a3,
    name: "about-callia"
  }, {
    path: "/account",
    component: _83dfe29a,
    name: "account",
    children: [{
      path: "add-address",
      component: _9b22c628,
      name: "account-add-address"
    }, {
      path: "addresses",
      component: _ad8c7074,
      name: "account-addresses"
    }, {
      path: "change-name",
      component: _2f004cac,
      name: "account-change-name"
    }, {
      path: "change-number",
      component: _776fffac,
      name: "account-change-number"
    }, {
      path: "change-password",
      component: _17bf4f88,
      name: "account-change-password"
    }, {
      path: "edit-address",
      component: _a74bc186,
      name: "account-edit-address"
    }, {
      path: "order-details",
      component: _7b82dc67,
      name: "account-order-details"
    }, {
      path: "orders",
      component: _a658681e,
      name: "account-orders"
    }, {
      path: "view",
      component: _7d4d1e9e,
      name: "account-view"
    }]
  }, {
    path: "/black-friday",
    component: _4a00e952,
    name: "black-friday"
  }, {
    path: "/bouquet-subscription",
    component: _4304090e,
    name: "bouquet-subscription"
  }, {
    path: "/bouquetexperiences",
    component: _4f761438,
    name: "bouquetexperiences"
  }, {
    path: "/bouquetkit",
    component: _3df0d176,
    name: "bouquetkit"
  }, {
    path: "/bulk-florals",
    component: _e46039e4,
    name: "bulk-florals"
  }, {
    path: "/callia-campus",
    component: _4883cc1c,
    name: "callia-campus"
  }, {
    path: "/callias-birthday",
    component: _a9f91b12,
    name: "callias-birthday"
  }, {
    path: "/cart",
    component: _e08117ec,
    name: "cart"
  }, {
    path: "/change-password",
    component: _0012cdc4,
    name: "change-password"
  }, {
    path: "/collection",
    component: _6fa999f0,
    name: "collection"
  }, {
    path: "/contact-callia",
    component: _928789a6,
    name: "contact-callia"
  }, {
    path: "/corporate",
    component: _10884d6b,
    name: "corporate"
  }, {
    path: "/donations",
    component: _74b5f227,
    name: "donations"
  }, {
    path: "/en-ca",
    component: _2dfb1658,
    name: "index___en-ca"
  }, {
    path: "/events",
    component: _21236146,
    name: "events"
  }, {
    path: "/experience",
    component: _8c9cd058,
    name: "experience"
  }, {
    path: "/faq",
    component: _ca324bc8,
    name: "faq"
  }, {
    path: "/final-invoice-confirmation",
    component: _0e44a436,
    name: "final-invoice-confirmation"
  }, {
    path: "/flower-day",
    component: _4029a8d8,
    name: "flower-day"
  }, {
    path: "/fr-ca",
    component: _2dfb1658,
    name: "index___fr-ca"
  }, {
    path: "/galentines-day",
    component: _3292d825,
    name: "galentines-day"
  }, {
    path: "/gift-cards",
    component: _5543de20,
    name: "gift-cards"
  }, {
    path: "/greet-not-found",
    component: _cdff8d6c,
    name: "greet-not-found"
  }, {
    path: "/greets",
    component: _5e9ff9f4,
    name: "greets"
  }, {
    path: "/holiday-offers",
    component: _649df516,
    name: "holiday-offers"
  }, {
    path: "/holidays",
    component: _6fe224f6,
    name: "holidays"
  }, {
    path: "/mothers-day",
    component: _204e42e5,
    name: "mothers-day"
  }, {
    path: "/people",
    component: _2876d73c,
    name: "people"
  }, {
    path: "/places",
    component: _58b07eb6,
    name: "places"
  }, {
    path: "/rewards",
    component: _7dec6fac,
    name: "rewards"
  }, {
    path: "/rickis-x-callia",
    component: _04c6ab75,
    name: "rickis-x-callia"
  }, {
    path: "/sign-in",
    component: _211f388a,
    name: "sign-in"
  }, {
    path: "/sign-up",
    component: _0406ba31,
    name: "sign-up"
  }, {
    path: "/special-offers",
    component: _328af3d6,
    name: "special-offers"
  }, {
    path: "/thanksgiving",
    component: _67fef701,
    name: "thanksgiving"
  }, {
    path: "/the-fine-print",
    component: _1cbd3320,
    name: "the-fine-print"
  }, {
    path: "/valentines-day",
    component: _91c1d014,
    name: "valentines-day"
  }, {
    path: "/workshops",
    component: _0e24b952,
    name: "workshops"
  }, {
    path: "/about-callia/our-story",
    component: _140ca585,
    name: "about-callia-our-story"
  }, {
    path: "/en-ca/about-callia",
    component: _3af280a3,
    name: "about-callia___en-ca"
  }, {
    path: "/en-ca/account",
    component: _83dfe29a,
    name: "account___en-ca",
    children: [{
      path: "add-address",
      component: _9b22c628,
      name: "account-add-address___en-ca"
    }, {
      path: "addresses",
      component: _ad8c7074,
      name: "account-addresses___en-ca"
    }, {
      path: "change-name",
      component: _2f004cac,
      name: "account-change-name___en-ca"
    }, {
      path: "change-number",
      component: _776fffac,
      name: "account-change-number___en-ca"
    }, {
      path: "change-password",
      component: _17bf4f88,
      name: "account-change-password___en-ca"
    }, {
      path: "edit-address",
      component: _a74bc186,
      name: "account-edit-address___en-ca"
    }, {
      path: "order-details",
      component: _7b82dc67,
      name: "account-order-details___en-ca"
    }, {
      path: "orders",
      component: _a658681e,
      name: "account-orders___en-ca"
    }, {
      path: "view",
      component: _7d4d1e9e,
      name: "account-view___en-ca"
    }]
  }, {
    path: "/en-ca/black-friday",
    component: _4a00e952,
    name: "black-friday___en-ca"
  }, {
    path: "/en-ca/bouquet-subscription",
    component: _4304090e,
    name: "bouquet-subscription___en-ca"
  }, {
    path: "/en-ca/bouquetexperiences",
    component: _4f761438,
    name: "bouquetexperiences___en-ca"
  }, {
    path: "/en-ca/bouquetkit",
    component: _3df0d176,
    name: "bouquetkit___en-ca"
  }, {
    path: "/en-ca/bulk-florals",
    component: _e46039e4,
    name: "bulk-florals___en-ca"
  }, {
    path: "/en-ca/callia-campus",
    component: _4883cc1c,
    name: "callia-campus___en-ca"
  }, {
    path: "/en-ca/callias-birthday",
    component: _a9f91b12,
    name: "callias-birthday___en-ca"
  }, {
    path: "/en-ca/cart",
    component: _e08117ec,
    name: "cart___en-ca"
  }, {
    path: "/en-ca/change-password",
    component: _0012cdc4,
    name: "change-password___en-ca"
  }, {
    path: "/en-ca/collection",
    component: _6fa999f0,
    name: "collection___en-ca"
  }, {
    path: "/en-ca/contact-callia",
    component: _928789a6,
    name: "contact-callia___en-ca"
  }, {
    path: "/en-ca/corporate",
    component: _10884d6b,
    name: "corporate___en-ca"
  }, {
    path: "/en-ca/donations",
    component: _74b5f227,
    name: "donations___en-ca"
  }, {
    path: "/en-ca/events",
    component: _21236146,
    name: "events___en-ca"
  }, {
    path: "/en-ca/experience",
    component: _8c9cd058,
    name: "experience___en-ca"
  }, {
    path: "/en-ca/faq",
    component: _ca324bc8,
    name: "faq___en-ca"
  }, {
    path: "/en-ca/final-invoice-confirmation",
    component: _0e44a436,
    name: "final-invoice-confirmation___en-ca"
  }, {
    path: "/en-ca/flower-day",
    component: _4029a8d8,
    name: "flower-day___en-ca"
  }, {
    path: "/en-ca/galentines-day",
    component: _3292d825,
    name: "galentines-day___en-ca"
  }, {
    path: "/en-ca/gift-cards",
    component: _5543de20,
    name: "gift-cards___en-ca"
  }, {
    path: "/en-ca/greet-not-found",
    component: _cdff8d6c,
    name: "greet-not-found___en-ca"
  }, {
    path: "/en-ca/greets",
    component: _5e9ff9f4,
    name: "greets___en-ca"
  }, {
    path: "/en-ca/holiday-offers",
    component: _649df516,
    name: "holiday-offers___en-ca"
  }, {
    path: "/en-ca/holidays",
    component: _6fe224f6,
    name: "holidays___en-ca"
  }, {
    path: "/en-ca/mothers-day",
    component: _204e42e5,
    name: "mothers-day___en-ca"
  }, {
    path: "/en-ca/people",
    component: _2876d73c,
    name: "people___en-ca"
  }, {
    path: "/en-ca/places",
    component: _58b07eb6,
    name: "places___en-ca"
  }, {
    path: "/en-ca/rewards",
    component: _7dec6fac,
    name: "rewards___en-ca"
  }, {
    path: "/en-ca/rickis-x-callia",
    component: _04c6ab75,
    name: "rickis-x-callia___en-ca"
  }, {
    path: "/en-ca/sign-in",
    component: _211f388a,
    name: "sign-in___en-ca"
  }, {
    path: "/en-ca/sign-up",
    component: _0406ba31,
    name: "sign-up___en-ca"
  }, {
    path: "/en-ca/special-offers",
    component: _328af3d6,
    name: "special-offers___en-ca"
  }, {
    path: "/en-ca/thanksgiving",
    component: _67fef701,
    name: "thanksgiving___en-ca"
  }, {
    path: "/en-ca/the-fine-print",
    component: _1cbd3320,
    name: "the-fine-print___en-ca"
  }, {
    path: "/en-ca/valentines-day",
    component: _91c1d014,
    name: "valentines-day___en-ca"
  }, {
    path: "/en-ca/workshops",
    component: _0e24b952,
    name: "workshops___en-ca"
  }, {
    path: "/events/how-it-works",
    component: _719cd20e,
    name: "events-how-it-works"
  }, {
    path: "/fr-ca/about-callia",
    component: _3af280a3,
    name: "about-callia___fr-ca"
  }, {
    path: "/fr-ca/account",
    component: _83dfe29a,
    name: "account___fr-ca",
    children: [{
      path: "add-address",
      component: _9b22c628,
      name: "account-add-address___fr-ca"
    }, {
      path: "addresses",
      component: _ad8c7074,
      name: "account-addresses___fr-ca"
    }, {
      path: "change-name",
      component: _2f004cac,
      name: "account-change-name___fr-ca"
    }, {
      path: "change-number",
      component: _776fffac,
      name: "account-change-number___fr-ca"
    }, {
      path: "change-password",
      component: _17bf4f88,
      name: "account-change-password___fr-ca"
    }, {
      path: "edit-address",
      component: _a74bc186,
      name: "account-edit-address___fr-ca"
    }, {
      path: "order-details",
      component: _7b82dc67,
      name: "account-order-details___fr-ca"
    }, {
      path: "orders",
      component: _a658681e,
      name: "account-orders___fr-ca"
    }, {
      path: "view",
      component: _7d4d1e9e,
      name: "account-view___fr-ca"
    }]
  }, {
    path: "/fr-ca/black-friday",
    component: _4a00e952,
    name: "black-friday___fr-ca"
  }, {
    path: "/fr-ca/bouquet-subscription",
    component: _4304090e,
    name: "bouquet-subscription___fr-ca"
  }, {
    path: "/fr-ca/bouquetexperiences",
    component: _4f761438,
    name: "bouquetexperiences___fr-ca"
  }, {
    path: "/fr-ca/bouquetkit",
    component: _3df0d176,
    name: "bouquetkit___fr-ca"
  }, {
    path: "/fr-ca/bulk-florals",
    component: _e46039e4,
    name: "bulk-florals___fr-ca"
  }, {
    path: "/fr-ca/callia-campus",
    component: _4883cc1c,
    name: "callia-campus___fr-ca"
  }, {
    path: "/fr-ca/callias-birthday",
    component: _a9f91b12,
    name: "callias-birthday___fr-ca"
  }, {
    path: "/fr-ca/cart",
    component: _e08117ec,
    name: "cart___fr-ca"
  }, {
    path: "/fr-ca/change-password",
    component: _0012cdc4,
    name: "change-password___fr-ca"
  }, {
    path: "/fr-ca/collection",
    component: _6fa999f0,
    name: "collection___fr-ca"
  }, {
    path: "/fr-ca/contact-callia",
    component: _928789a6,
    name: "contact-callia___fr-ca"
  }, {
    path: "/fr-ca/corporate",
    component: _10884d6b,
    name: "corporate___fr-ca"
  }, {
    path: "/fr-ca/donations",
    component: _74b5f227,
    name: "donations___fr-ca"
  }, {
    path: "/fr-ca/events",
    component: _21236146,
    name: "events___fr-ca"
  }, {
    path: "/fr-ca/experience",
    component: _8c9cd058,
    name: "experience___fr-ca"
  }, {
    path: "/fr-ca/faq",
    component: _ca324bc8,
    name: "faq___fr-ca"
  }, {
    path: "/fr-ca/final-invoice-confirmation",
    component: _0e44a436,
    name: "final-invoice-confirmation___fr-ca"
  }, {
    path: "/fr-ca/flower-day",
    component: _4029a8d8,
    name: "flower-day___fr-ca"
  }, {
    path: "/fr-ca/galentines-day",
    component: _3292d825,
    name: "galentines-day___fr-ca"
  }, {
    path: "/fr-ca/gift-cards",
    component: _5543de20,
    name: "gift-cards___fr-ca"
  }, {
    path: "/fr-ca/greet-not-found",
    component: _cdff8d6c,
    name: "greet-not-found___fr-ca"
  }, {
    path: "/fr-ca/greets",
    component: _5e9ff9f4,
    name: "greets___fr-ca"
  }, {
    path: "/fr-ca/holiday-offers",
    component: _649df516,
    name: "holiday-offers___fr-ca"
  }, {
    path: "/fr-ca/holidays",
    component: _6fe224f6,
    name: "holidays___fr-ca"
  }, {
    path: "/fr-ca/mothers-day",
    component: _204e42e5,
    name: "mothers-day___fr-ca"
  }, {
    path: "/fr-ca/people",
    component: _2876d73c,
    name: "people___fr-ca"
  }, {
    path: "/fr-ca/places",
    component: _58b07eb6,
    name: "places___fr-ca"
  }, {
    path: "/fr-ca/rewards",
    component: _7dec6fac,
    name: "rewards___fr-ca"
  }, {
    path: "/fr-ca/rickis-x-callia",
    component: _04c6ab75,
    name: "rickis-x-callia___fr-ca"
  }, {
    path: "/fr-ca/sign-in",
    component: _211f388a,
    name: "sign-in___fr-ca"
  }, {
    path: "/fr-ca/sign-up",
    component: _0406ba31,
    name: "sign-up___fr-ca"
  }, {
    path: "/fr-ca/special-offers",
    component: _328af3d6,
    name: "special-offers___fr-ca"
  }, {
    path: "/fr-ca/thanksgiving",
    component: _67fef701,
    name: "thanksgiving___fr-ca"
  }, {
    path: "/fr-ca/the-fine-print",
    component: _1cbd3320,
    name: "the-fine-print___fr-ca"
  }, {
    path: "/fr-ca/valentines-day",
    component: _91c1d014,
    name: "valentines-day___fr-ca"
  }, {
    path: "/fr-ca/workshops",
    component: _0e24b952,
    name: "workshops___fr-ca"
  }, {
    path: "/people/drivers",
    component: _20bf4ab5,
    name: "people-drivers"
  }, {
    path: "/wedding-flowers/city-landing",
    component: _667a9572,
    name: "wedding-flowers-city-landing"
  }, {
    path: "/wedding-flowers/deposit-confirmation",
    component: _14cac804,
    name: "wedding-flowers-deposit-confirmation"
  }, {
    path: "/wedding-flowers/how-it-works",
    component: _6aa9c7b7,
    name: "wedding-flowers-how-it-works"
  }, {
    path: "/wedding-flowers/old-index",
    component: _8e02d1bc,
    name: "wedding-flowers-old"
  }, {
    path: "/wedding-flowers/tip",
    component: _39c15511,
    name: "wedding-flowers-tip"
  }, {
    path: "/wedding-flowers/wedding-form",
    component: _5fd38417,
    name: "wedding-flowers-wedding-form"
  }, {
    path: "/wedding-flowers/wedding-gallery",
    component: _1581ac4f,
    name: "wedding-flowers-wedding-gallery"
  }, {
    path: "/en-ca/about-callia/our-story",
    component: _140ca585,
    name: "about-callia-our-story___en-ca"
  }, {
    path: "/en-ca/events/how-it-works",
    component: _719cd20e,
    name: "events-how-it-works___en-ca"
  }, {
    path: "/en-ca/people/drivers",
    component: _20bf4ab5,
    name: "people-drivers___en-ca"
  }, {
    path: "/en-ca/wedding-flowers/city-landing",
    component: _667a9572,
    name: "wedding-flowers-city-landing___en-ca"
  }, {
    path: "/en-ca/wedding-flowers/deposit-confirmation",
    component: _14cac804,
    name: "wedding-flowers-deposit-confirmation___en-ca"
  }, {
    path: "/en-ca/wedding-flowers/how-it-works",
    component: _6aa9c7b7,
    name: "wedding-flowers-how-it-works___en-ca"
  }, {
    path: "/en-ca/wedding-flowers/old-index",
    component: _8e02d1bc,
    name: "wedding-flowers-old___en-ca"
  }, {
    path: "/en-ca/wedding-flowers/tip",
    component: _39c15511,
    name: "wedding-flowers-tip___en-ca"
  }, {
    path: "/en-ca/wedding-flowers/wedding-form",
    component: _5fd38417,
    name: "wedding-flowers-wedding-form___en-ca"
  }, {
    path: "/en-ca/wedding-flowers/wedding-gallery",
    component: _1581ac4f,
    name: "wedding-flowers-wedding-gallery___en-ca"
  }, {
    path: "/fr-ca/about-callia/our-story",
    component: _140ca585,
    name: "about-callia-our-story___fr-ca"
  }, {
    path: "/fr-ca/events/how-it-works",
    component: _719cd20e,
    name: "events-how-it-works___fr-ca"
  }, {
    path: "/fr-ca/people/drivers",
    component: _20bf4ab5,
    name: "people-drivers___fr-ca"
  }, {
    path: "/fr-ca/wedding-flowers/city-landing",
    component: _667a9572,
    name: "wedding-flowers-city-landing___fr-ca"
  }, {
    path: "/fr-ca/wedding-flowers/deposit-confirmation",
    component: _14cac804,
    name: "wedding-flowers-deposit-confirmation___fr-ca"
  }, {
    path: "/fr-ca/wedding-flowers/how-it-works",
    component: _6aa9c7b7,
    name: "wedding-flowers-how-it-works___fr-ca"
  }, {
    path: "/fr-ca/wedding-flowers/old-index",
    component: _8e02d1bc,
    name: "wedding-flowers-old___fr-ca"
  }, {
    path: "/fr-ca/wedding-flowers/tip",
    component: _39c15511,
    name: "wedding-flowers-tip___fr-ca"
  }, {
    path: "/fr-ca/wedding-flowers/wedding-form",
    component: _5fd38417,
    name: "wedding-flowers-wedding-form___fr-ca"
  }, {
    path: "/fr-ca/wedding-flowers/wedding-gallery",
    component: _1581ac4f,
    name: "wedding-flowers-wedding-gallery___fr-ca"
  }, {
    path: "/order/update/guest/order-details",
    component: _1bfd87d8,
    name: "order-update-guest-order-details"
  }, {
    path: "/en-ca/order/update/guest/order-details",
    component: _1bfd87d8,
    name: "order-update-guest-order-details___en-ca"
  }, {
    path: "/fr-ca/order/update/guest/order-details",
    component: _1bfd87d8,
    name: "order-update-guest-order-details___fr-ca"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }, {
    path: "/en-ca/order/update/guest/verify/:orderId?",
    component: _51d8382e,
    name: "order-update-guest-verify-orderId___en-ca"
  }, {
    path: "/fr-ca/order/update/guest/verify/:orderId?",
    component: _51d8382e,
    name: "order-update-guest-verify-orderId___fr-ca"
  }, {
    path: "/order/update/guest/verify/:orderId?",
    component: _51d8382e,
    name: "order-update-guest-verify-orderId"
  }, {
    path: "/en-ca/care-tips/:productType?",
    component: _a17142a2,
    name: "care-tips-productType___en-ca"
  }, {
    path: "/en-ca/city/:city",
    component: _50476f93,
    name: "city-city___en-ca"
  }, {
    path: "/en-ca/occasion/:occasion?",
    component: _fa5c2cf0,
    name: "occasion-occasion___en-ca"
  }, {
    path: "/en-ca/product/:sku?",
    component: _18d55530,
    name: "product-sku___en-ca"
  }, {
    path: "/en-ca/province/:province?",
    component: _245f2c4c,
    name: "province-province___en-ca"
  }, {
    path: "/en-ca/v/:greetVideoRedirect?",
    component: _313318fa,
    name: "v-greetVideoRedirect___en-ca"
  }, {
    path: "/fr-ca/care-tips/:productType?",
    component: _a17142a2,
    name: "care-tips-productType___fr-ca"
  }, {
    path: "/fr-ca/city/:city",
    component: _50476f93,
    name: "city-city___fr-ca"
  }, {
    path: "/fr-ca/occasion/:occasion?",
    component: _fa5c2cf0,
    name: "occasion-occasion___fr-ca"
  }, {
    path: "/fr-ca/product/:sku?",
    component: _18d55530,
    name: "product-sku___fr-ca"
  }, {
    path: "/fr-ca/province/:province?",
    component: _245f2c4c,
    name: "province-province___fr-ca"
  }, {
    path: "/fr-ca/v/:greetVideoRedirect?",
    component: _313318fa,
    name: "v-greetVideoRedirect___fr-ca"
  }, {
    path: "/en-ca/video/:video?/share",
    component: _2e913e0a,
    name: "video-video-share___en-ca"
  }, {
    path: "/fr-ca/video/:video?/share",
    component: _2e913e0a,
    name: "video-video-share___fr-ca"
  }, {
    path: "/en-ca/city/:city?/:occasion",
    component: _c5eadc6c,
    name: "city-city-occasion___en-ca"
  }, {
    path: "/fr-ca/city/:city?/:occasion",
    component: _c5eadc6c,
    name: "city-city-occasion___fr-ca"
  }, {
    path: "/care-tips/:productType?",
    component: _a17142a2,
    name: "care-tips-productType"
  }, {
    path: "/city/:city",
    component: _50476f93,
    name: "city-city"
  }, {
    path: "/occasion/:occasion?",
    component: _fa5c2cf0,
    name: "occasion-occasion"
  }, {
    path: "/product/:sku?",
    component: _18d55530,
    name: "product-sku"
  }, {
    path: "/province/:province?",
    component: _245f2c4c,
    name: "province-province"
  }, {
    path: "/v/:greetVideoRedirect?",
    component: _313318fa,
    name: "v-greetVideoRedirect"
  }, {
    path: "/video/:video?/share",
    component: _2e913e0a,
    name: "video-video-share"
  }, {
    path: "/city/:city?/:occasion",
    component: _c5eadc6c,
    name: "city-city-occasion"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
